import { css } from 'styled-components';
import { theme } from './../theme';
export const tabNavigationOutline = css `
  outline: 2px solid ${theme.colors.kiwiLight};
`;
export const tabNavigationStyle = css `
  &:focus:not(:focus-visible) {
    outline: none;
  }

  &:focus-visible {
    ${tabNavigationOutline}
  }
`;
//# sourceMappingURL=tabNavigationStyle.js.map